import {
  CircleLink,
  Facebook,
  FacebookHref,
  Instagram,
  InstagramHref,
  Linkedin,
  LinkedinHref,
} from "./social";
import { HStack } from "@chakra-ui/react";

const socials = [
  { icon: Facebook, href: FacebookHref },
  { icon: Instagram, href: InstagramHref },
  { icon: Linkedin, href: LinkedinHref },
];

export const SocialMediaLinks = () => (
  <HStack align="center" justify="center" spacing="4" color="blue.800">
    {socials.map(({ icon: Icon, href }, idx) => (
      <CircleLink
        key={idx}
        href={href}
        isExternal
        _hover={{ transform: "scale(1.05)" }}
      >
        <Icon m="8px" boxSize="20px" />
      </CircleLink>
    ))}
  </HStack>
);
